import { HStack, VStack } from '@chakra-ui/react';
import { Button as ButtonComponent, SectionCard } from '@themes/aegix';
import { DrawerComponent } from '../../ui/drawerComponent';
import { DetailRow } from '../DetailRow';
import type { EventSite } from '../../../types/ReunificationTypes';

interface LocationDetailDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  site: EventSite | undefined;
}

export function LocationDetailDrawer({
  isOpen,
  onClose,
  site,
}: LocationDetailDrawerProps) {
  return (
    <DrawerComponent
      isOpen={isOpen}
      onClose={onClose}
      title="Location Detail"
      size="md"
      closeOnOutside={false}
      closeOnEsc={false}
      footer={
        <HStack gap={3} width="100%">
          <ButtonComponent visual="secondary" onClick={onClose} data-e2e="close-button">
            Close
          </ButtonComponent>
        </HStack>
      }
    >
      {site ? (
        <SectionCard title="Location Details">
          <VStack align="stretch" gap={0}>
            <DetailRow label="Name" value={site.site_name} dataE2e="location-detail-name" />
            <DetailRow label="Type" value={site.site_type} dataE2e="location-detail-type" />
            <DetailRow label="Role" value={site.role_display} dataE2e="location-detail-role" />
            <DetailRow label="Active" value={site.is_active ? 'Yes' : 'No'} dataE2e="location-detail-active" />
            <DetailRow
              label="Activated"
              value={
                site.activated_at
                  ? new Date(site.activated_at).toLocaleString()
                  : '---'
              }
              dataE2e="location-detail-activated"
            />
            {site.notes && <DetailRow label="Notes" value={site.notes} dataE2e="location-detail-notes" />}
          </VStack>
        </SectionCard>
      ) : null}
    </DrawerComponent>
  );
}
